var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "booking-confirmation main-content" },
    [
      _c(
        "el-descriptions",
        { attrs: { column: 24, colon: false } },
        [
          _c("el-descriptions-item", {
            attrs: { span: 3.5, label: "Booking Received by Carrier:" }
          }),
          _c(
            "el-descriptions-item",
            { attrs: { span: 16.5 } },
            [
              _c("el-tag", { attrs: { type: _vm.acLabel.type } }, [
                _vm._v(_vm._s(_vm.acLabel.label))
              ]),
              _c(
                "el-tag",
                {
                  staticStyle: { "margin-left": "5px" },
                  attrs: { type: "info" }
                },
                [_vm._v(_vm._s(_vm.acEdiReceipt.dateCreated))]
              ),
              _c(
                "el-tooltip",
                {
                  staticClass: "item",
                  attrs: {
                    effect: "dark",
                    content: _vm.acEdiReceipt.remarks,
                    placement: "bottom-end"
                  }
                },
                [
                  _vm.acLabel.type === "warning"
                    ? _c("span", [_vm._v(_vm._s(_vm.remarks))])
                    : _vm._e()
                ]
              )
            ],
            1
          ),
          _c("el-descriptions-item", { attrs: { span: 4 } }, [
            _c(
              "div",
              { staticStyle: { display: "flex" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", plain: "" },
                    on: { click: _vm.syncData }
                  },
                  [_vm._v("Update to booking information")]
                ),
                _c(
                  "el-tooltip",
                  {
                    staticClass: "item",
                    attrs: {
                      effect: "dark",
                      content: _vm.help,
                      placement: "bottom-end"
                    }
                  },
                  [
                    _c("el-tag", { staticStyle: { margin: "3px" } }, [
                      _vm._v("?")
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _c(
        "el-descriptions",
        { attrs: { column: 14, colon: false } },
        [
          _c("el-descriptions-item", {
            attrs: { span: 2, label: "Booking Confirmation Version:" }
          }),
          _c("el-descriptions-item", { attrs: { span: 8 } }, [
            _c(
              "div",
              { staticStyle: { display: "flex" } },
              [
                _c("cargo-pagination", {
                  attrs: {
                    layout: "prev, pager, next",
                    limit: 1,
                    page: _vm.page,
                    total: _vm.ediReceiptData.length
                  },
                  on: { pagination: _vm.changeEdiReceiptVersion }
                }),
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "300px", "margin-top": "7px" },
                    attrs: { placeholder: "-Please select-", clearable: false },
                    on: { change: _vm.reloadDifferent },
                    model: {
                      value: _vm.filter.differentStatus,
                      callback: function($$v) {
                        _vm.$set(_vm.filter, "differentStatus", $$v)
                      },
                      expression: "filter.differentStatus"
                    }
                  },
                  _vm._l(_vm.chooseDifferent, function(item) {
                    return _c("el-option", {
                      key: item.code,
                      attrs: { label: item.name, value: item.code }
                    })
                  }),
                  1
                )
              ],
              1
            )
          ]),
          _c("el-descriptions-item", {
            attrs: { span: 2, label: "Latest Amendment Time:" }
          }),
          _c(
            "el-descriptions-item",
            { attrs: { span: 2 } },
            [
              _c("el-tag", { attrs: { type: "info" } }, [
                _vm._v(_vm._s(_vm.selectData.time + " (UTC)"))
              ])
            ],
            1
          )
        ],
        1
      ),
      _c("h1", { staticStyle: { "text-align": "center" } }, [
        _vm._v(_vm._s(_vm.selectStatus))
      ]),
      _c("div", { staticStyle: { display: "flex" } }, [
        _c("h2", [_vm._v("S/O NO.")]),
        _c(
          "p",
          {
            class: _vm.differentSoNo ? "warning" : "",
            staticStyle: { margin: "9.6px 20px" }
          },
          [_vm._v(_vm._s(_vm.selectData.soNo))]
        ),
        _c("h2", [_vm._v("MB/L NO.")]),
        _c(
          "p",
          {
            class: _vm.differentMbl ? "warning" : "",
            staticStyle: { margin: "9.6px 20px" }
          },
          [_vm._v(_vm._s(_vm.selectData.mbl))]
        )
      ]),
      _c("div", { staticClass: "grid-view" }, [
        _c("div", { staticClass: "main-content" }, [
          _c(
            "div",
            { staticClass: "section grid-wrapper" },
            [
              _vm.port.rowData && _vm.port.rowData.length > 0
                ? _c("cargo-ag-grid", {
                    attrs: {
                      "show-side-bar": false,
                      "grid-options": _vm.port.gridOptions,
                      "column-defs": _vm.port.columnDefs,
                      "row-data": _vm.port.rowData,
                      "grid-style": "height:300px;",
                      "wrap-text": true
                    }
                  })
                : _vm._e(),
              _vm.time.rowData && _vm.time.rowData.length > 0
                ? _c("cargo-ag-grid", {
                    staticStyle: { "margin-top": "20px" },
                    attrs: {
                      "show-side-bar": false,
                      "grid-options": _vm.time.gridOptions,
                      "column-defs": _vm.time.columnDefs,
                      "grid-style": "height:100%;",
                      "row-data": _vm.time.rowData
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _c("span", { staticStyle: { height: "28px" } }),
      _vm._l(_vm.containerData, function(item, index) {
        return _c(
          "el-descriptions",
          {
            key: index,
            attrs: { column: 10, border: "", direction: "vertical" }
          },
          [
            _c("el-descriptions-item", { attrs: { label: "Item No." } }, [
              _c(
                "span",
                {
                  class:
                    item.differentFields && item.differentFields["itemNo"]
                      ? "warning"
                      : ""
                },
                [_vm._v(_vm._s(item.itemNo))]
              )
            ]),
            _c("el-descriptions-item", { attrs: { label: "Container No." } }, [
              _c(
                "span",
                {
                  class:
                    item.differentFields && item.differentFields["containerNo"]
                      ? "warning"
                      : ""
                },
                [_vm._v(_vm._s(item.containerNo))]
              )
            ]),
            _c("el-descriptions-item", { attrs: { label: "EQ Size" } }, [
              _c(
                "span",
                {
                  class:
                    item.differentFields && item.differentFields["eqSize"]
                      ? "warning"
                      : ""
                },
                [_vm._v(_vm._s(item.eqSize))]
              )
            ]),
            _c("el-descriptions-item", { attrs: { label: "EQ Type" } }, [
              _c(
                "span",
                {
                  class:
                    item.differentFields && item.differentFields["eqType"]
                      ? "warning"
                      : ""
                },
                [_vm._v(_vm._s(item.eqType))]
              )
            ]),
            _c(
              "el-descriptions-item",
              { attrs: { label: "Description of Goods" } },
              [
                _c(
                  "span",
                  {
                    class:
                      item.differentFields &&
                      item.differentFields["goodDescriptions"]
                        ? "warning"
                        : ""
                  },
                  [_vm._v(_vm._s(item.goodDescriptions))]
                )
              ]
            ),
            _c("el-descriptions-item", { attrs: { label: "Quantity" } }, [
              _c(
                "span",
                {
                  class:
                    item.differentFields && item.differentFields["quantity"]
                      ? "warning"
                      : ""
                },
                [_vm._v(_vm._s(item.quantity))]
              )
            ]),
            _c("el-descriptions-item", { attrs: { label: "Packing" } }, [
              _c(
                "span",
                {
                  class:
                    item.differentFields && item.differentFields["packingName"]
                      ? "warning"
                      : ""
                },
                [_vm._v(_vm._s(item.packingName))]
              )
            ]),
            _c("el-descriptions-item", { attrs: { label: "Gross Weight" } }, [
              _c(
                "span",
                {
                  class:
                    item.differentFields && item.differentFields["weight"]
                      ? "warning"
                      : ""
                },
                [_vm._v(_vm._s(item.weight))]
              )
            ]),
            _c("el-descriptions-item", { attrs: { label: "CBM" } }, [
              _c(
                "span",
                {
                  class:
                    item.differentFields && item.differentFields["cbm"]
                      ? "warning"
                      : ""
                },
                [_vm._v(_vm._s(item.cbm))]
              )
            ]),
            _c("el-descriptions-item", { attrs: { label: "SOC/COC" } }, [
              _c(
                "span",
                {
                  class:
                    item.differentFields && item.differentFields["socCoc"]
                      ? "warning"
                      : ""
                },
                [_vm._v(_vm._s(item.socCoc))]
              )
            ]),
            _c(
              "el-descriptions-item",
              {
                attrs: {
                  "label-style": { display: "none" },
                  "content-style": { padding: 0 }
                }
              },
              [
                _c(
                  "el-descriptions",
                  { attrs: { column: 2, border: "", colon: false } },
                  [
                    _c(
                      "el-descriptions-item",
                      {
                        attrs: {
                          label: "Empty Equipment Pick Up Address",
                          span: 2
                        }
                      },
                      [
                        _c(
                          "span",
                          {
                            class:
                              item.differentFields &&
                              item.differentFields["facilityDetails"]
                                ? "warning"
                                : ""
                          },
                          [_vm._v(_vm._s(item.facilityDetails))]
                        )
                      ]
                    ),
                    _c(
                      "el-descriptions-item",
                      { attrs: { label: "Delivery Address", span: 2 } },
                      [
                        _c(
                          "span",
                          {
                            class:
                              item.differentFields &&
                              item.differentFields["equipmentDelivery"]
                                ? "warning"
                                : ""
                          },
                          [_vm._v(_vm._s(item.equipmentDelivery))]
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      }),
      _vm.currentCount < _vm.totalContainer
        ? _c(
            "div",
            { staticClass: "show-more", on: { click: _vm.loadMoreContainer } },
            [
              _c("p", { staticStyle: { "margin-bottom": "5px" } }, [
                _vm._v(_vm._s(_vm.totalContainer - _vm.currentCount + " more"))
              ]),
              _c("i", {
                staticClass: "el-icon-d-arrow-right",
                staticStyle: { transform: "rotate(90deg)" }
              })
            ]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }